var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"formWrapper",staticClass:"form-wrapper"},[_c('el-row',[_c('div',[_vm._v("没有支持在线表单功能，无法使用！")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }